<script setup>
defineProps({
  inline: { default: false, type: Boolean },
  label: { default: "Loading", type: String },
  size: {
    default: "md",
    type: String,
    validator: (v) => ["sm", "md", "lg", "xl"].includes(v)
  }
});
</script>

<template>
  <div v-if="!inline" class="flex justify-center">
    <div
      role="status"
      :aria-label="label"
      :class="[
        'inline-block animate-spin rounded-full border-2 border-[var(--gl-spinner-track-color-default)] border-t-[var(--gl-spinner-segment-color-default)]',
        size === 'sm' && 'h-4 w-4',
        size === 'md' && 'h-6 w-6',
        size === 'lg' && 'h-8 w-8',
        size === 'xl' && 'h-16 w-16'
      ]"
    >
      <span class="sr-only">{{ label }}</span>
    </div>
  </div>
  <div
    v-else
    role="status"
    :aria-label="label"
    :class="[
      'inline-block animate-spin rounded-full border-2 border-[var(--gl-spinner-track-color-default)] border-t-[var(--gl-spinner-segment-color-default)]',
      size === 'sm' && 'h-4 w-4',
      size === 'md' && 'h-6 w-6',
      size === 'lg' && 'h-8 w-8',
      size === 'xl' && 'h-16 w-16'
    ]"
  >
    <span class="sr-only">{{ label }}</span>
  </div>
</template>
